let FuncionalidadeIdEnum = {
  TAREFAS: 209,
  RETOMAR_CONCILIACAO: 5011
}

export default FuncionalidadeIdEnum



// WEBPACK FOOTER //
// ./client/enum/funcionalidadeId.js